$(document).ready(function() {

	$(document).on('click', '#product-request-offer', function (e) {
		e.preventDefault();

		const url = $(this).data('url');

		var urlParams = '?p='+$(this).data('id');

		if ($('#surface').val() != '') {
			urlParams += '&surface=' + $('#surface').val();
		}
		if ($('#thickness option:selected').val() != '') {
			urlParams += '&thickness=' + $('#thickness option:selected').val();
		}

		window.location = url + urlParams;
	});

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/products.js